// API Configuration
export const BASE_URL = "https://sociopedia-production.up.railway.app";
// export const BASE_URL = "http://localhost:3001";
